import React, { memo } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Inbox from '@mui/icons-material/Inbox';
import SearchOff from '@mui/icons-material/SearchOff';
import { smallPillButtonSx } from './styles';

interface EmptyJobsStateProps {
  /** True when jobs exist but the active filters hide all of them. */
  filtered: boolean;
  onResetFilters: () => void;
}

const EmptyJobsState: React.FC<EmptyJobsStateProps> = ({ filtered, onResetFilters }) => {
  const Icon = filtered ? SearchOff : Inbox;
  return (
    <Box sx={{ py: 7, px: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, textAlign: 'center', borderTop: 1, borderColor: 'divider' }}>
      <Icon sx={{ fontSize: 36, color: 'text.disabled' }} />
      <Typography sx={{ fontWeight: 600 }}>{filtered ? 'No jobs match' : 'No jobs yet'}</Typography>
      <Typography sx={{ color: 'text.secondary', fontSize: 13 }}>
        {filtered ? 'Try a different status or type filter.' : 'Exports, label batches and mapping documents you run will show up here.'}
      </Typography>
      {filtered ? (
        <Button variant="outlined" onClick={onResetFilters} sx={{ ...smallPillButtonSx, mt: 1 }}>
          Clear filters
        </Button>
      ) : null}
    </Box>
  );
};

export default memo(EmptyJobsState);
